import { iws_event } from "./../../tools.ts";

/**********************************************************************************************************
* Auteur        : ABON
* Date          : 01/04/2011
* Description   : Classes de gestion de pliage depliage d'un menu
***********************************************************************************************************/
export class IsiSubMenuManager {

    msMenuGroup: string; //Groupe du menu (principal,module...)
    msMenuId: string;
    msParentId: string;
    //iOriginalHeight;         //taille d'affichage du menu  en complet sur la page
    //iCurrentHeight;          //taille courante du menu
    msRestrict: string; //Restriction sur le on mouse over(pour gerer notamment un probleme de hover sur la combo des langues)
    miLeft: number; // taille du positionnement a gauche
    mbIsScrolling: boolean;
    miWidth: number;
    // on indique que le menu est cache
    mbMenuDisplay: boolean;

    // Permet d'indiquer si les actions sont activées
    actionsEnabled: boolean;

    initialized: boolean;
    mpParentJQuery: JQuery;
    mpBoxJQuery: JQuery;
    mpBoxPanel: JQuery;
    timer: number;

    

    constructor(menuId: string, left: number, onMoOutRestrict: string, menuGroup: string, parentId: string) {
        ///<summary>Classe de gestion de l'affichage d'un sous menu.</summary>
        ///<param name="menuId">Identifiant du menu.</param>
        ///<param name="left">position de gauche du menu</param>
        ///<param name="onMoOutRestrict">restriction sur l'id d'un element lors d'un mouse out du menu(probleme du passage sur les items de la combo des langues)</param>
        ///<param name="menuGroup">groupe du menu</param>
        ///<param name="parentId">id de la div cliquable pour deplier le menu</param>
        // Attributs

        this.msMenuGroup = menuGroup; //Groupe du menu (principal,module...)
        this.msMenuId = menuId;
        this.msParentId = parentId;
        //this.iOriginalHeight;         //taille d'affichage du menu  en complet sur la page
        //this.iCurrentHeight;          //taille courante du menu
        this.msRestrict = onMoOutRestrict; //Restriction sur le on mouse over(pour gerer notamment un probleme de hover sur la combo des langues)
        this.miLeft = left; // taille du positionnement a gauche
        this.mbIsScrolling = false;
        this.miWidth = 0;
        // on indique que le menu est cache
        this.mbMenuDisplay = false;

        // Permet d'indiquer si les actions sont activées
        this.actionsEnabled = true;        
    }

    get id() {
        return this.msMenuId;
    }

    get parentId() {
        return this.msParentId;
    }

    init() {
        if (!this.initialized) {
            if (this.msParentId != null)
                this.mpParentJQuery = jQuery("#" + this.msParentId);

            this.mpBoxJQuery = jQuery("#" + this.msMenuId); //boite du menu
            this.mpBoxPanel = jQuery("#" + this.msMenuId + '_Panel'); // le pannel du menu
            this.initialized = true;
        }
    }
    /**
    * Gestion du changement de l'image sur le passage d'un menu
    */
    OnRollOver(obj, showRollOverImg) {

        ///<summary>Fonction appelee sur le passage de la souris au dessus d'un menu.</summary>
        ///<param name="obj">l'objet sur lequel la souris passe par dessus.</param>
        ///<param name="showRollOverImg">Indique si l'on doit afficher le rollover (cas d'un menu non cliquable)</param>
        this.init();
    }
    /**
    * Methode donnant le position gauche du menu a redefinir si besoin de positionnement dyanmique (exempe menu principal)
    */
    getLeftPos() {
        return this.miLeft;
    }

    /**
    * Methode a redefinir pour la fermeture d'un menu
    */
    OnClose() {
        ///<summary>Methode a redefinir pour la fermeture d'un menu (sans timeout)</summary>
    }

    /**
    * Lancement de la cloture d'un menu
    */
    ClosingRequest() {
        //uiCore.log("IsiSubMenuManager.ClosingRequest");
        ///<summary>Lance la fermeture d'un menu avec timeout 500ms par defaut.</summary>
        this.timer = window.setTimeout(function (me) {
            return function() {
                me.OnClose();
            }
        }(this), 500);
    }

    /**
    * lancement de l'annimation du menu vers le bas
    */
    MoveDown() {
        ///<summary>Depliage du menu/summary>
        // s'il y a une menu encours et que celui-ci n'est pas le menu que l'on tente d'afficher alors on le replis.

        //uiCore.log("IsiSubMenuManager.MoveDown");
        this.init();
        this._ensurePanelPosition();

        if (screenCore.menuManager.subMenuManagers[this.msMenuGroup] && (screenCore.menuManager.subMenuManagers[this.msMenuGroup] != this)) {
            screenCore.menuManager.subMenuManagers[this.msMenuGroup].CloseSubMenu();
            screenCore.menuManager.removeOpenedMenu(this.msMenuId);
        }

        this.mpBoxPanel.css("display", "block");

        // CLEM - 101715 - Calcul de la taille du submenu pour le menu principale pour faire le scroll vertical ou non
        if (this.msMenuGroup == mnuPrinc) {
            var heightFrame;
            var heightSubMenu;
            // taille de l ecran - l'entete
            heightFrame = isiApp.display.GetBodyClientHeight() - jQuery("#DivBannerGlobal").height();
            // Taille du sous menu
            this.mpBoxJQuery.find("[class^='mnuContent']").css("height", "");
            heightSubMenu = this.mpBoxJQuery.height();
            // Si le sous menu est + grand que la div frame, alors on lui set une taille pour qu'elle puisse etre scrollable
            if (heightFrame < heightSubMenu) {
                this.mpBoxJQuery.find("[class^='mnuContent']").height(heightFrame);

            } else {
                this.mpBoxJQuery.find("[class^='mnuContent']").height(heightSubMenu);
            }
        }

        //this.mpBoxJQuery.animate({ "top": "+=" + this.iCurrentHeight + "px" }, 160);
        this.mbMenuDisplay = true;

        screenCore.menuManager.subMenuManagers[this.msMenuGroup] = this;
        screenCore.menuManager.registerOpenedMenu(this.msMenuId);

        var jMenu;
        jMenu = this.mpParentJQuery
        if (!jMenu) {
            jMenu = this.mpBoxJQuery
        }
        this.afterMoveDownOverridable(jMenu);
    }
    afterMoveDownOverridable(jMenu) {
        jMenu.addClass("opened");
    }

    /**
    * lancement de l'annimation du menu vers le haut
    */
    MoveUp() {
        //uiCore.log("IsiSubMenuManager.MoveUp");
        ///<summary>Lance la fermeture graphique d'un menu.</summary>
        this.CloseSubMenu();
    }

    /**
   * Donne l'identifiant de l'élément HTML doit on vient de sortir
   */
    _getCurrentEventRelatedTargetId(ev) {

        let currentEvent = iws_event(ev);
        let result = {
            id: "",
            x: -1,
            y: -1,
            position: {}
        };

        if (currentEvent) {

            result.x = currentEvent.pageX;
            result.y = currentEvent.pageY;

            if (currentEvent.relatedTarget && currentEvent.relatedTarget.id !== "") {
                //isiApp.log("_getCurrentEventRelatedTargetId (relatedTarget) id=" + currentEvent.relatedTarget.id);
                result.id = currentEvent.relatedTarget.id;
            } else if (currentEvent.originalTarget && currentEvent.originalTarget.id !== "") {
                //isiApp.log("_getCurrentEventRelatedTargetId (originalTarget) id=" + currentEvent.originalTarget.id);
                result.id = currentEvent.originalTarget.id;
            }
            //if (currentEvent.currentTarget && currentEvent.currentTarget.id !== "") {
            //    isiApp.log("_getCurrentEventRelatedTargetId (currentTarget) id=" + currentEvent.currentTarget.id);
            //}
        }

        return result;
    }

    _isInBox(target) {

        let bigBtn = document.getElementById("DivMenuBigbtn_Panel");

        if (bigBtn) {
            target.position = bigBtn.getBoundingClientRect();
        }

        if (target.position) {

            //let p = target.position;
            //isiApp.log("x,y=(" + target.x + ", " + target.y + ") box(left,top,width,height)=(" + p.left + "," + p.top + "," + p.width + "," + p.height + ")");
            //isiApp.log("range-x : " + p.left + "-" + (p.left + p.width));
            //isiApp.log("range-y : " + p.top + "-" + (p.top + p.height));

            if (target.x <= -1 || target.y <= -1) { return true; }

            if (target.x < target.position.left || target.x > target.position.left + target.position.width) { return false; }
            if (target.y < target.position.top || target.y > target.position.top + target.position.height) { return false; }
        }
        return true;
    }

    /**
     * Contrôle que l'élément HTML doit on vient de sortir est celui de la restriction
     */
    _canClose(target) {

        // s'il n'y a pas de restriction, aucun élément HTML n'est impactés
        if (typeof (this.msRestrict) === "undefined" || this.msRestrict === "") {
            //isiApp.log("_canClose pas de restriction");
            return false;// va fermer le menu
        }

        // s'il existe une restriction et qu'un identifiant est donné, on check
        if (target.id !== "") {
            let r = this.msRestrict === target.id;
            //isiApp.log("_canClose msRestrict(" + this.msRestrict + ") == id=(" + id + ") -> " + r);
            return r;// ca dépend
        }

        if (this._isInBox(target)) {
            //isiApp.log("In The Box !");
            return true;// va laisser le menu ouvert
        }

        //isiApp.log("_canClose pas de restriction");
        return false; // va fermer le menu
    }

    /**
    * Gestion du traitement sur deplacement de la souris en dehors du menu
    */
    OnMouseOut(ev) {
        ///<summary>Methode appele sur le mouseout d'un menu (parent + sous menu)</summary>
        // probleme du onmouse out sur une liste de selection d'une drop down
        //http://support.microsoft.com/kb/254614
        // sauf que ce KB ne fonctionne plus pour le menu principal lorsque l'on passe au dessus du menu 
        // et que l'on sort par le haut => reprise du code normea

        //isiApp.log("OnMouseOut");    
        if (!this._canClose(this._getCurrentEventRelatedTargetId(ev))) {

            this.init();
            //KK repris de normea en sortie de combo on donne le focus sur le panel pour fermer la combo (notamment des langues)... amazing...
            this.mpBoxJQuery.children(".MenuBegin").children(".MenuCenter").children(".MenuContent").focus();

            // si le menu n'etait deja pas affiche alors on fait juste le callback associe
            if (this.mbMenuDisplay == false) {
                //isiApp.log("OnMouseOut -> 2");
                //GBAU - 31/03/2015 - RWD
                if (typeof (this.OnMouseOutCallBack) != 'undefined') {
                    this.OnMouseOutCallBack();
                }
            } else {
                //sinon on lance une demande de fermeture du menu (avec timer)
                //isiApp.log("OnMouseOut -> ClosingRequest");
                this.ClosingRequest();
            }

        }

        //uiCore.log("IsiSubMenuManager.OnMouseOut fin");
    }

    /**
    * Gestion du traitement sur deplacement de la souris au dessus du menu
    */
    OnMouseOver(ev) {
        ///<summary>Methode  appele lors du passage de la souris sur le menu</summary>
        this.init();
        var bShowMenu;
        var curMngr;
        curMngr = screenCore.menuManager.subMenuManagers[this.msMenuGroup];

        //let evv = iws_event(ev);
        //if (evv && evv.currentTarget) {
        //    isiApp.log("OnMouseOver currentTarget=" + evv.currentTarget.id);
        //}

        // si un menu etait actif alors on le ferme (sans animation / timer)
        if (curMngr && (curMngr != this) && curMngr.msMenuGroup == this.msMenuGroup) {
            bShowMenu = curMngr.mbMenuDisplay;
            curMngr.CloseSubMenu();
            if (bShowMenu) {
                screenCore.menuManager.removeOpenedMenu(curMngr.msMenuId);
            }
        }

        // si une demande de fermeture etait en cours on la supprime
        if (this.timer) {
            //isiApp.log("OnMouseOver -> clearTimeout");
            clearTimeout(this.timer);
            this.timer = null;
        }

        // on appel la methode spe pour ce menu pour le onmouseover
        this.OnMouseOverCallBack();

        // si le menu d'avant etait affiche alors on affiche celui-ci
        if (bShowMenu && this.mbMenuDisplay == false) {
            this.MoveDown();
            screenCore.menuManager.registerOpenedMenu(this.msMenuId);
        }
        screenCore.menuManager.subMenuManagers[this.msMenuGroup] = this;

        //uiCore.log("IsiSubMenuManager.OnMouseOver fin");
    }

    /**
    * Gestib du click sur un menu parent
    */
    OnClick() {
        ///<summary>Methode appelee sur le clique sur un menu</summary>
        this.init();

        if (this.actionsEnabled) {

            if (this.mbMenuDisplay == true) {

                //isiApp.log("OnClick");

                if (!this._canClose({ id: "iCbMenuLangue" })) {
                    this.MoveUp();
                }

            }
            else {
                this.MoveDown();
                // focus notamment pour gerer l'accesskey
                if (this.mpParentJQuery)
                    this.mpParentJQuery.focus();
            }

            // on est au dessus du menu on appel le call back (cas du clique puis reclique sans bouger la souris)
            this.OnMouseOverCallBack();

            //uiCore.log("IsiSubMenuManager.OnClick fin");
        }

    }

    CloseSubMenu() {
        /// <summary>Fermeture du menu proprement dite</summary>
        this.init();
        this.mpBoxJQuery.stop();
        //this.mpBoxJQuery.css('top', -this.iCurrentHeight);
        this.mpBoxPanel.css("display", "none");
        //GBAU - 31/03/2015 - RWD
        if (typeof (this.OnMouseOutCallBack) != 'undefined') {
            this.OnMouseOutCallBack();
        }
        this.mbMenuDisplay = false;

        screenCore.menuManager.removeOpenedMenu(this.msMenuId);

        var jMenu;
        jMenu = this.mpParentJQuery
        if (!jMenu) {
            jMenu = this.mpBoxJQuery
        }
        this.afterCloseSubMenuOverridable(jMenu);

    }
    afterCloseSubMenuOverridable(jMenu) {
        //TODO: RWD
        if (this.mpBoxJQuery.attr("id") == "DivMenuRacBandeau") {
            $("#DivRacBandeauContener").removeClass("opened");
        }
        jMenu.removeClass("opened");
    }

    /**
    * Liberation des ressources utilisees par la classe
    * 
    */
    dispose() {
        this.mpBoxJQuery = null;
        this.mpBoxPanel = null;
    }

    /**
    * Permet de désactiver les actions (clicks)
    * 
    */
    disableActions() {
        this.actionsEnabled = false;
    }
    /**
    * Permet de d'activer les actions (clicks)
    * 
    */
    enableActions() {
        this.actionsEnabled = true;
    }

    _ensurePanelPosition() {
        if (this.mpParentJQuery) {
            jQuery(this.mpBoxPanel).css("top", (this.mpParentJQuery.offsetTopAsInt() + this.mpParentJQuery.height()) + "px");
        }
    }

    OnMouseOverCallBack() {

    }

    OnMouseOutCallBack() {

    }
}

export class IsiSubMainMenuManager extends IsiSubMenuManager {

    getLeftPos() {
        return document.getElementById(this.id).offsetLeft - 2;
    }
    // appele apres la traitement OnMouseOver du manager
    OnMouseOverCallBack() {
        var pMenu = jQuery("#" + this.msParentId);
        pMenu.addClass("hover");
    }
    // appele apres la traitement OnMouseOut du manager
    OnMouseOutCallBack() {
        var pMenu = jQuery("#" + this.msParentId);
        pMenu.removeClass("hover");
    }
    // appele apres la traitement fermeture du manager
    OnClose() {
        this.CloseSubMenu();
    };

}
